import BraftEditor, { BraftEditorProps } from "braft-editor";
import "./Editor.Component.less";

const EditorComponent = (props: BraftEditorProps) => {
  return (
    <BraftEditor
      language="en"
      {...props}
      className={`EditorComponent ${props.className}`}
    />
  );
};

export default EditorComponent;
